import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

const ManagementCardTextBody = ({ children }: PropsWithChildren) => {
    return (
        <Text
            fontVariant="body2"
            color={colorsPalettes.carbon["300"]}
        >
            {children}
        </Text>
    );
};

export default ManagementCardTextBody;
